import { render } from "./UserAccountLogs.vue?vue&type=template&id=5abbb7c1"
import script from "./UserAccountLogs.vue?vue&type=script&lang=js"
export * from "./UserAccountLogs.vue?vue&type=script&lang=js"

import "./UserAccountLogs.vue?vue&type=style&index=0&id=5abbb7c1&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/logs/UserAccountLogs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5abbb7c1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5abbb7c1', __exports__)) {
    console.log('reload')
    api.reload('5abbb7c1', __exports__)
  }
  
  module.hot.accept("./UserAccountLogs.vue?vue&type=template&id=5abbb7c1", () => {
    console.log('re-render')
    api.rerender('5abbb7c1', render)
  })

}


export default __exports__